import { createContext, useContext } from "react";

/**
 * DOM node for the Sales detail drawer. SalesPage owns a full-page-height right
 * column and publishes its node here; each sub-tab portals its
 * TransactionDetailDrawer into it, so the drawer spans the whole page (beside
 * the header, pushing New Sale left) and scrolls independently of the list.
 * Null when no host is mounted (e.g. a sub-tab rendered in isolation in tests).
 */
export const SalesDrawerSlotContext = createContext<HTMLElement | null>(null);

export const useSalesDrawerSlot = (): HTMLElement | null =>
  useContext(SalesDrawerSlotContext);
